exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-button-text {\n    padding: .5rem 1rem;\n    min-width: 120px;\n    vertical-align: top;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/event/content-add/content-add.component.css
// module id = ../../../../../src/app/event/content-add/content-add.component.css
// module chunks = main